export default __webpack_public_path__ + "static/media/cover.03621c2e.png";